import { render, staticRenderFns } from "./PermissionDoc.vue?vue&type=template&id=51c33884&scoped=true&"
import script from "./PermissionDoc.vue?vue&type=script&lang=js&"
export * from "./PermissionDoc.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDoc.vue?vue&type=style&index=0&id=51c33884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c33884",
  null
  
)

export default component.exports